import anime from 'animejs'

// blink animation
const createBlinkAnimation = (target, ctx) => {
  ctx = ctx || {}
  target = target.toLowerCase()
  ctx.blinking = anime({
    targets: `#${target}_left_eye_lids, #${target}_right_eye_lids`, // get left and right eyelids
    opacity: [{
        value: 1,
        duration: 300
      },
      {
        value: 0,
        duration: 1
      }
    ],
    offset: (Math.random() * 2000) + 6000, // random offset between 6-8 seconds
    loop: true
  })
}

export {
  createBlinkAnimation
}



// WEBPACK FOOTER //
// ./src/assets/js/utils/createBlinkAnimation.js